'use client';

import { FC, SVGProps } from 'react';
import ArrowUpIcon from '~/assets/icons/arrow-up.svg';
import BurgerIconClose from '~/assets/icons/burger-menu-close.svg';
import BurgerIcon from '~/assets/icons/burger-menu.svg';
import CheckIconOutline from '~/assets/icons/check.svg';
import CheckIcon from '~/assets/icons/checkbox-checkmark.svg';
import ChevronIcon from '~/assets/icons/chevron.svg';
import CloseIcon from '~/assets/icons/close.svg';
import DownloadIcon from '~/assets/icons/download.svg';
import EmailIcon from '~/assets/icons/email-send.svg';
import ArrowIcon from '~/assets/icons/how-we-work-arrow.svg';
import LocationMarkerIcon from '~/assets/icons/location-marker.svg';
import LocationIcon from '~/assets/icons/location.svg';
import MaxIcon from '~/assets/icons/max.svg';
import OpenExternal from '~/assets/icons/open-external.svg';
import PhoneCallIcon from '~/assets/icons/phone-call.svg';
import PhoneHeaderIcon from '~/assets/icons/phone-header.svg';
import CallIcon from '~/assets/icons/phone.svg';
import SliderArrowIcon from '~/assets/icons/slider-navigation-arrow.svg';
import TelegramIcon from '~/assets/icons/telegram.svg';
import ProfileIcon from '~/assets/icons/user-profile.svg';
import WhatsAppIcon from '~/assets/icons/whatsapp.svg';

const iconMap = {
  download: DownloadIcon,
  burger: BurgerIcon,
  'burger-close': BurgerIconClose,
  checkmark: CheckIcon,
  check: CheckIconOutline,
  chevron: ChevronIcon,
  close: CloseIcon,
  email: EmailIcon,
  arrow: ArrowIcon,
  phone: PhoneCallIcon,
  'slider-arrow': SliderArrowIcon,
  telegram: TelegramIcon,
  whatsapp: WhatsAppIcon,
  profile: ProfileIcon,
  location: LocationIcon,
  'location-marker': LocationMarkerIcon,
  max: MaxIcon,
  open: OpenExternal,
  call: CallIcon,
  'phone-header': PhoneHeaderIcon,
  'arrow-up': ArrowUpIcon,
};

export type IconName = keyof typeof iconMap;

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
}

const Icon: FC<IconProps> = ({ name, ...props }) => {
  const IconComponent = iconMap[name];
  return <IconComponent {...props} />;
};

export default Icon;
